import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import WizardGroupsFlowCanvas from "./WizardGroupsFlowCanvas";
import {addNewFlowGroup} from "../wizardFlowActions";
import {WIZARD_GROUP_TYPES} from "../WizardItem/wizardItemInterface";

const getNodeTypeByIndex = (wizardDraggingGroupIndex) => {
  switch (wizardDraggingGroupIndex) {
    case -6:
      return WIZARD_GROUP_TYPES.custom
    case -5:
      return WIZARD_GROUP_TYPES.inputs
    case -4:
      return WIZARD_GROUP_TYPES.contact
    case -3:
      return WIZARD_GROUP_TYPES.appointment
    case -2:
      return WIZARD_GROUP_TYPES.review
    case -1:
      return WIZARD_GROUP_TYPES.success
    default:
      return ""
  }
}

const WizardGroupsFlow = (props) => {

  const {wizardActiveItem, addNewFlowGroup, wizardDraggingGroupIndex, wizardFlowActiveMode, intl, allFilterGroups,
    featureGroups, filtersReceived, wizardFiltersLoading} = props;
  const {wizardGroups} = wizardActiveItem;

  const [isDraggedOver, setIsDraggedOver] = useState(false);
  const [flowInstance, setFlowInstance] = useState(null);
  const [flowLoading, setFlowLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setFlowLoading(false)
    }, 300)
  }, [])

  const onMouseOver = () => {
    if (Number.isInteger(wizardDraggingGroupIndex) && !isDraggedOver) {
      setIsDraggedOver(true);
    }
  };

  const onMouseLeave = () => {
    if (isDraggedOver) {
      setIsDraggedOver(false);
    }
  };

  const onMouseUp = (event) => {
    if (Number.isInteger(wizardDraggingGroupIndex)) {
      // console.log("onMouseUp event", event);
      const nodeType = getNodeTypeByIndex(wizardDraggingGroupIndex);
      const listItem = document.querySelector(`.wizard-sidebar__list-item[data-index="${wizardDraggingGroupIndex}"]`);
      if (listItem && listItem.dataset.group) {
        const featureGroup = nodeType
          ? {groupName: intl.formatMessage({id: "wizard.group.type." + nodeType})}
          : wizardFlowActiveMode === WIZARD_GROUP_TYPES.group
            ? featureGroups.find(filterGroup => filterGroup.groupName === listItem.dataset.group)
            : allFilterGroups.find(filterGroup => filterGroup.name === listItem.dataset.group)
        if (featureGroup) {
          const currentViewport = flowInstance ? flowInstance.getViewport() : null;
          const position = {
            x: event.clientX - 468 - (currentViewport ? currentViewport.x : 290),
            y: event.clientY - 100 - (currentViewport ? currentViewport.y : 100),
          }
          console.log("position", position);
          addNewFlowGroup(wizardActiveItem, featureGroup, nodeType, position)
        }
      } else {
        console.log("No listItem!", listItem, wizardDraggingGroupIndex);
      }
      setIsDraggedOver(false);
    }
  };

  const setAvailableFilterConnections = (wizardEdges) => {
    return wizardGroups.map(wizardGroup => {
      if (wizardGroup.nodeType === WIZARD_GROUP_TYPES.filter) {
        const filterGroup = allFilterGroups.find(filterGroup => filterGroup.name === wizardGroup.groupName);
        const existingEdges = wizardEdges.filter(wizardEdge => wizardEdge.target === wizardGroup.id);
        wizardGroup.noAvailableFilters = !!filterGroup && !!existingEdges.length && existingEdges.every(edge => {
          const groupFrom = wizardGroups.find(wizGroup => {
            return (wizGroup.id !== wizardGroup.id) && (wizGroup.id === edge.source) && (wizGroup.nodeType === WIZARD_GROUP_TYPES.group)
          });
          return groupFrom && filtersReceived[groupFrom.groupName] && !filterGroup.values.some(filterValue => {
            return filtersReceived[groupFrom.groupName].includes(filterValue.id);
          })
        })
      }
      return wizardGroup
    })
  }

  return (
    <div className={"wizard-flow" + (isDraggedOver ? " wizard-flow--dragged" : "")
      + (flowLoading || wizardFiltersLoading ? " wizard-flow--loading" : "")}
         onMouseOver={onMouseOver}
         onMouseUp={onMouseUp}
         onMouseLeave={onMouseLeave}>
      <WizardGroupsFlowCanvas wizardActiveItem={wizardActiveItem}
                              setFlowInstance={setFlowInstance}
                              setAvailableFilterConnections={setAvailableFilterConnections}/>
      {flowLoading || wizardFiltersLoading ? <div className="ui-loader"/> : null}
    </div>
  )
}

WizardGroupsFlow.propTypes = {
  wizardActiveItem: PropTypes.object.isRequired
}

const mapStateToProps = (store) => {
  const {wizardDraggingGroupIndex, wizardFlowActiveMode, wizardFiltersLoading} = store.wizardState;
  const {featuresGroups} = store.projectScopeNew;
  const {allFilterGroups, filtersReceived} = store.featuresFiltersState;

  return {
    wizardFiltersLoading,
    wizardDraggingGroupIndex,
    wizardFlowActiveMode,
    featureGroups: featuresGroups,
    allFilterGroups,
    filtersReceived,
  };
};

const mapDispatchToProps = {
  addNewFlowGroup,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(WizardGroupsFlow))
